<template lang="pug">
  div
    page_header(title="Week Day", subhead="Edit")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "weekday.index", params: {id: weekid}}')
        i.feather-arrow-left
        | Back

    .row
      .col-sm-6
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-12
                form_input(type="text" name="name" label="Name" placeholder="Enter Week Day Name" v-model="form.name" :required="true")  

                .mb-3
                  label.form-label Start Date
                  datepicker(v-model="form.start" format="YYYY-MM-DD HH:mm" :no-label="true")
                  form_error(:errors="errors?errors['start']:[]")

                .mb-3
                  label.form-label End Date
                  datepicker(v-model="form.end" format="YYYY-MM-DD HH:mm" :no-label="true")
                  form_error(:errors="errors?errors['end']:[]")

                form_select(name="status" label="status" placeholder="status" v-model="form.status" :options="['active','inactive']" :required="true")
                

            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import formError from '@/components/formErrors';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import { mapActions, mapState } from 'vuex'
export default {
  name: 'Products',
  props: ['id'],
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn,
    datepicker: VueCtkDateTimePicker,
    form_error: formError,
  },
  data(){
    return {
      domains: [],
      form: {
      }
    }
  },
  computed: {
    weekid(){
      if(this.form.week_id){
        return this.form.week_id;
      }
    },
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    submit(){
      var vm = this;
      this.call({_vm:this, endpoint: 'admin/weekday/'+this.id, method: 'PUT', data: this.form})
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: `admin/weekday/${this.id}/edit`, method: 'GET'}).then(async (response)=>{

      await vm.$nextTick();

      vm.form = response.data;

    })
  }
}
</script>
